import React from 'react'
import PropTypes from 'prop-types'
import { NavigationBar } from '@stone-payments/jade'

const Header = ({ onClose }) => (
  <NavigationBar
    background="body"
    onNavigate={onClose}
    navigateType="close"
    label="Voltar"
  />
)

Header.propTypes = {
  onClose: PropTypes.func,
}

Header.defaultProps = {
  onClose: null,
}

export default Header
